import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import TextFieldGroup from '../common/TextFieldGroup';
import { createProfile } from '../../actions/profileActions';

class CreateProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
        fullname: '',
        email: '',
        errors: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const profileData = {
        fullname: this.state.fullname,
        email: this.state.email
    };

    this.props.createProfile(profileData, this.props.history);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="create-profile">
        <div className="container">
          <div className="row">
            <div className="col-md-8 m-auto">
              <h1 className="display-4 text-center">新增您的資訊</h1>
              <small className="d-block pb-3">* = 必填</small>
              <form onSubmit={this.onSubmit}>
                <TextFieldGroup
                  placeholder="* 暱稱"
                  name="fullname"
                  value={this.state.fullname}
                  onChange={this.onChange}
                  error={errors.fullname}
                  info="在0xPlay.com中使用的暱稱"
                />
                <TextFieldGroup
                  placeholder="* E-mail"
                  name="skills"
                  value={this.state.email}
                  onChange={this.onChange}
                  error={errors.email}
                  info="請輸入您的電子郵件信箱，以便取得即時通知"
                />
                <input
                  type="submit"
                  value="Submit"
                  className="btn btn-info btn-block mt-4"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CreateProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  profile: state.profile,
  errors: state.errors
});

export default connect(mapStateToProps, { createProfile })(
  withRouter(CreateProfile)
);



// WEBPACK FOOTER //
// ./src/components/create-profile/CreateProfile.js